export enum EnumMasterInsuranceSubState {
  "insurance_creating" = "insurance_creating",
  "insurance_package_creating" = "insurance_package_creating",
  "validating" = "validating",
  "completed" = "completed",
}

export const MasterInsuranceSubStateKey = "INSURANCE_SUB_STATE_KEY";
